
const StartVisitStyle = theme => ({
    buttonStyle: {
        boxShadow: 'none',
        width: 170,
        height: 40,
        textTransform: 'none',
        fontSize: 24,
        lineHeight: "29px",
        padding: 0,
        fontWeight: "bold",
        backgroundColor: '#00ad50',
        fontFamily: "Proxima Nova",
        '&:hover': {
            backgroundColor: '#00ad50',
            boxShadow: 'none',
        },
        '&:active': {
            backgroundColor: '#00ad50',
            boxShadow: 'none',
        },
        '&:focus': {
            backgroundColor: '#00ad50',
            boxShadow: 'none',
        },
        '&:disabled': {
            color: 'white',
            boxShadow: 'none',
        },
    },
    visitWrapper: {
        position: "relative"
    },
    tooltipStyle: {
        width: 170,
        height: 40,
        minHeight: 40,
        maxHeight: 40,
        display: "block"
    }
})

export default StartVisitStyle;